// extracted by mini-css-extract-plugin
export default {"heroSection":"adi_heroSection__uGbpv","heroText":"adi_heroText__nsfgt","infoSection":"adi_infoSection__Tec27","contentSection":"adi_contentSection__iIi6p"};